import React, { useContext } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Aide } from '@mummssoftware/utils/roleData';
import { useStyles } from '@mummssoftware/common-ui/VisitAttributeSelector';
import { Context } from '../../context';
import defaults from '../../translations/en.json';

const translations: NonNullable<mumms.JSONObject> = defaults;

type NurseNotificationCheckboxProps = {
  updateNurseNotified: () => void;
  isChecked: boolean;
};

export const NurseNotificationCheckbox = (
  props: NurseNotificationCheckboxProps,
) => {
  const { isChecked, updateNurseNotified } = props;
  const { patient, currentUser } = useContext(Context);
  const { userRoleGroups } = currentUser;
  const classes = useStyles();

  // check the existance of patient here to confirm if this is a patient visit
  // or a non-patient visit.  Upcomming pim work will provide a boolean indicating
  // this.
  const showNurseNotificationCheckBox =
    patient && userRoleGroups.includes(Aide);

  return (
    <>
      {showNurseNotificationCheckBox ? (
        <FormGroup id="nurse-notification">
          <FormControlLabel
            control={
              <Checkbox checked={isChecked} onChange={updateNurseNotified} />
            }
            label={translations.visitNurseNotified}
            classes={{
              label: classes.label,
            }}
          />
        </FormGroup>
      ) : null}
    </>
  );
};
